import _ from "lodash";
import { errorMsg } from "../../const/constant";
import { history, logger, httpGet, httpPost, label } from "../../framework";

function createAction(result, type, additionalPayload) {
  let returnResult = {};
  if (result instanceof Error) {
    returnResult = {
      type,
      payload: Object.assign(
        { code: "EC9999", error: result.message },
        additionalPayload
      ),
    };
  } else if (result.result === "E99998") {
    history.push("/"); // redirect to login page after session timed out
    const resultPayload = {
      result: result.result,
      error: result.error,
      csrf: result.csrf,
    };
    returnResult = { type, payload: resultPayload };
  } else {
    let resultPayload = { result: result.result, csrf: result.csrf };
    resultPayload =
      result.error !== undefined
        ? Object.assign(resultPayload, { error: result.error })
        : resultPayload;
    resultPayload =
      result.value !== undefined
        ? Object.assign(resultPayload, { value: result.value })
        : resultPayload;
    resultPayload =
      additionalPayload !== undefined
        ? Object.assign(resultPayload, additionalPayload)
        : resultPayload;
    returnResult = { type, payload: resultPayload };
  }
  return returnResult;
}

function createErrorAction(result, type, additionalPayload) {
  const r = typeof result === "string" ? new Error(result) : result;
  return createAction(r, type, additionalPayload);
}

export function loginAction(value) {
  return async (dispatch) => {
    let response = null;
    try {
      dispatch({ type: "DATA-LOADING-BEGIN" });
      response = await httpPost("/auth/ptpsLogin", value);
      if (response.result === "0") {
        dispatch(createAction(response, "LOGIN-SUCCESS"));
      } else {
        dispatch(createErrorAction(response, "LOGIN-ERROR"));
        if (response.error) errorMsg(label(response.error, "i18n"));
      }
    } catch (err) {
      dispatch(createErrorAction(err, "LOGIN-ERROR"));
    } finally {
      dispatch({ type: "DATA-LOADING-END" });
      return response;
    }
  };
}

export function logoutAction(csrf) {
  return async (dispatch) => {
    try {
      dispatch({ type: "DATA-LOADING-BEGIN" });
      const response = await httpPost("/auth/logout", { csrf });
      if (response.result === "0") {
        dispatch(createAction(response, "LOGOUT-SUCCESS"));
        history.push(response.redirectURL);
      } else {
        dispatch(createErrorAction(response, "LOGOUT-ERROR"));
        if (response.error) {
          errorMsg(response.error);
          throw response.error;
        }
      }
    } catch (err) {
      history.push("/ptpsauth");
    } finally {
      dispatch({ type: "DATA-LOADING-END" });
    }
  };
}

export function authenticateAction() {
  return async (dispatch) => {
    try {
      dispatch({ type: "DATA-LOADING-BEGIN" });
      const response = await httpGet("/auth/ptpsAuth");
      await dispatch(getRequestAmount());
      if (response.result === "0") {
        dispatch(createAction(response, "AUTHENTICATE-SUCCESS"));
      } else {
        dispatch(createErrorAction(response, "AUTHENTICATE-ERROR"));
        if (response.error) errorMsg(label(response.error, "i18n"));
      }
    } catch (err) {
      //history.push('/');
    } finally {
      dispatch({ type: "DATA-LOADING-END" });
    }
  };
}

export function fetchSession() {
  return async (dispatch) => {
    try {
      dispatch({ type: "DATA-LOADING-BEGIN" });
      const response = await httpGet("/auth/adfs/session");
      if (response.result === "0") {
        dispatch(createAction(response, "LOGIN-SUCCESS"));
        await dispatch(authenticateAction());
      } else {
        dispatch(createErrorAction(response, "AUTHENTICATE-ERROR"));
      }
    } catch (err) {
      dispatch(createErrorAction(err, "AUTHENTICATE-ERROR"));
    } finally {
      dispatch({ type: "DATA-LOADING-END" });
    }
  };
}

export function initConfigurationDataAction() {
  // logger.getLogger('initConfigurationDataAction').debug('start');
  return async (dispatch) => {
    try {
      dispatch({ type: "DATA-LOADING-BEGIN" });
      const response = await httpGet("/init/data");
      if (response.result === "0") {
        dispatch(createAction(response, "INIT-DATA-LOAD-SUCCESS"));
      } else {
        dispatch(createErrorAction(response, "INIT-DATA-LOAD-ERROR"));
        //history.push('/');
      }
    } catch (err) {
      //history.push('/');
    } finally {
      dispatch({ type: "DATA-LOADING-END" });
    }
  };
}

export function navigateAction(func, lang = "enUS", searchParams = undefined) {
  return async (dispatch, getState) => {
    dispatch(getRequestAmount());
    const state = getState();
    const currentFunction = state.dashboard.currentFunction;
    let searchP = {};
    if (searchParams) {
      for (const key of searchParams.keys()) {
        searchP[key] = searchParams.get(key);
      }
    }
    let routeTo = "";
    const path = "/ptps";
    if (currentFunction?.FUNC_KEY === func?.FUNC_KEY) return;

    if (func?.NAME) {
      let pathParams = "";
      if (func.path_param && Array.isArray(func.path_param)) {
        for (var i in func.path_param) {
          // logger.getLogger('param').debug(func.path_param[i]);
          pathParams = pathParams + "/" + func.path_param[i].urlParamVal;
        }
      }
      routeTo =
        path +
        (!_.isEmpty(func.BACKFUNCNAME) ? "/" + func.BACKFUNCNAME + "/" : "/") +
        func.NAME +
        pathParams;
    } else if (func !== undefined && func.length > 0) {
      routeTo =
        path +
        (!_.isEmpty(func[0].BACKFUNCNAME) !== null
          ? "/" + func[0].BACKFUNCNAME
          : "");
    } else {
      routeTo = path;
    }

    if (currentFunction.PAYLOADONEXIT)
      dispatch({ type: currentFunction.PAYLOADONEXIT });

    try {
      history.push(routeTo);
    } catch (err) {
      routeToPageNotFoundAction();
    }
    const action = {
      type: "NAVIGATE",
      payload: {
        to: func,
        curr: currentFunction,
        lang: lang,
        routeTo: routeTo,
        searchParams: searchP,
      },
    };
    dispatch(action);
  };
}

export function navigateBackAction(lang = "enUS", searchParams = undefined) {
  return async (dispatch, getState) => {
    const state = getState();
    const func = state.dashboard.currPageFunction;
    dispatch(navigateAction(func, lang, searchParams));
  };
}

export function routeToPageNotFoundAction() {
  return async () => {
    history.push("/pageNotFound");
  };
}

export function setFilteredInfoAction(filteredInfo) {
  return async (dispatch) => {
    const action = {
      type: "SET_FILTERED_INFO",
      payload: { filteredInfo: filteredInfo },
    };
    dispatch(action);
  };
}

export function entityListAction(entityName, csrf, query = undefined) {
  return async (dispatch) => {
    try {
      dispatch({ type: "DATA-LOADING-BEGIN" });
      let url = "/api/protected/data/list/" + entityName;
      if (query) {
        url += "?" + new URLSearchParams(query);
      }
      const response = await httpGet(url);
      if (response.result === "0") {
        dispatch(createAction(response, "DATA-LIST-SUCCESS"));
      } else {
        dispatch(createErrorAction(response, "DATA-LIST-ERROR"));
      }
    } catch (err) {
      dispatch(createErrorAction(err, "DATA-LIST-ERROR"));
    } finally {
      dispatch({ type: "DATA-LOADING-END" });
    }
  };
}

// Server side render (pagination)
export function entityFilterAction(entityName, csrf, offset, limit, params) {
  // FilterType: view, export
  return async (dispatch) => {
    const queryParams = new URLSearchParams();
    queryParams.append("offset", offset);
    queryParams.append("limit", limit);

    logger.debug("************************ entityFilterAction [start]");
    logger.debug(params);
    logger.debug("************************ entityFilterAction [end]");

    if (params) {
      queryParams.append("params", JSON.stringify(params));
      logger.debug(params);
    }

    try {
      dispatch({ type: "DATA-LOADING-BEGIN" });
      const response = await httpGet(
        `/api/protected/data/filter/${entityName}?${queryParams.toString()}`
      );
      if (response.result === "0") {
        dispatch(createAction(response, "DATA-FILTER-SUCCESS"));
      } else {
        dispatch(createErrorAction(response, "DATA-LIST-ERROR"));
      }
    } catch (err) {
      dispatch(createErrorAction(err, "DATA-LIST-ERROR"));
    } finally {
      dispatch({ type: "DATA-LOADING-END" });
    }
  };
}

export function entityCreateAction(entityName, data, csrf) {
  return async (dispatch) => {
    try {
      dispatch({ type: "DATA-LOADING-BEGIN" });
      let response = await httpPost(
        "/api/protected/data/create/" + entityName,
        { data, csrf }
      );
      if (response.result === "0") {
        dispatch(createAction(response, "DATA-CREATE-SUCCESS", { entityName }));
        response = await httpGet("/api/protected/data/list/" + entityName);
        if (response.result === "0") {
          dispatch(createAction(response, "DATA-LIST-SUCCESS"));
        } else {
          dispatch(createErrorAction(response, "DATA-LIST-ERROR"));
        }
      } else {
        dispatch(
          createErrorAction(response, "DATA-CREATE-ERROR", { entityName })
        );
      }
    } catch (err) {
      dispatch(createErrorAction(err, "DATA-CREATE-ERROR"));
    } finally {
      dispatch({ type: "DATA-LOADING-END" });
    }
  };
}

export function entityUpdateAction(entityName, recordKey, data, csrf) {
  return async (dispatch) => {
    logger.debug(" ****************************** entityName");
    logger.debug(entityName);
    logger.debug(" ****************************** recordKey");
    logger.debug(recordKey);
    logger.debug(" ****************************** data");
    logger.debug(data);

    try {
      dispatch({ type: "DATA-LOADING-BEGIN" });
      let response = await httpPost(
        "/api/protected/data/update/" + entityName,
        { key: recordKey, data, csrf }
      );
      if (response.result === "0") {
        dispatch(createAction(response, "DATA-UPDATE-SUCCESS", { entityName }));
        response = await httpGet("/api/protected/data/list/" + entityName);
        if (response.result === "0") {
          dispatch(createAction(response, "DATA-LIST-SUCCESS"));
        } else {
          dispatch(createErrorAction(response, "DATA-LIST-ERROR"));
        }
      } else {
        dispatch(
          createErrorAction(response, "DATA-UPDATE-ERROR", { entityName })
        );
      }
    } catch (err) {
      dispatch(createErrorAction(err, "DATA-UPDATE-ERROR"));
    } finally {
      dispatch({ type: "DATA-LOADING-END" });
    }
  };
}

export function entityDeleteAction(entityName, recordKey, csrf) {
  return async (dispatch) => {
    try {
      dispatch({ type: "DATA-LOADING-BEGIN" });
      let response = await httpPost(
        "/api/protected/data/delete/" + entityName,
        { key: recordKey, csrf }
      );
      if (response.result === "0") {
        dispatch(createAction(response, "DATA-DELETE-SUCCESS", { entityName }));
        response = await httpGet("/api/protected/data/list/" + entityName);
        if (response.result === "0") {
          dispatch(createAction(response, "DATA-LIST-SUCCESS"));
        } else {
          dispatch(createErrorAction(response, "DATA-LIST-ERROR"));
        }
      } else {
        dispatch(
          createErrorAction(response, "DATA-DELETE-ERROR", { entityName })
        );
      }
    } catch (err) {
      dispatch(createErrorAction(err, "DATA-DELETE-ERROR"));
    } finally {
      dispatch({ type: "DATA-LOADING-END" });
    }
  };
}

export function dataWrapper(apiPath, data = null, method = "POST") {
  //data: csrf included
  return async (dispatch, getState) => {
    let response = null;
    try {
      const state = getState();
      const csrf = state.action.csrf;
      dispatch({ type: "DATA-LOADING-BEGIN" });
      if (method === "POST")
        response = await httpPost("/api/protected/" + apiPath, {
          ...data,
          csrf: csrf,
        });
      else if (method === "GET")
        response = await httpGet("/api/protected/" + apiPath);
      if (response.result === "0") {
        dispatch(createAction(response, "DATA-LOADING-SUCCESS"));
      } else {
        dispatch(createErrorAction(response, "DATA-LOADING-ERROR"));
      }
    } catch (err) {
      dispatch(createErrorAction(err, "DATA-LOADING-ERROR"));
    } finally {
      dispatch({ type: "DATA-LOADING-END" });
      return response;
    }
  };
}

export function refreshCsrf() {
  return async (dispatch) => {
    let response = await httpGet("/refreshCsrf");
    if (response.result === "0") {
      dispatch(createAction(response, "REFRESH-CSRF"));
    }
  };
}

export function handleCheckOut() {
  return async (_, getState) => {
    //Check Validity of email address
    try {
      const state = getState();
      const csrf = state.action.csrf;
      const portalClient = state.portalClient;
      const order = {
        key: portalClient.selectedEvent.paymentRefIdPrefix,
        event_id: portalClient.selectedEvent.eventId,
        remarks: portalClient.selectedEvent.remarks,
        total_amount: portalClient.selectedEvent.totalAmount,
        payer_name: portalClient.selectedEvent.payerName,
        payer_email: portalClient.selectedEvent.emailAddress,
        orderDetails: portalClient.selectedEvent.shoppingCart.map(
          (orderDetail, idx) => {
            return {
              item_id: orderDetail.itemId,
              quantity: orderDetail.quantity,
              amount: orderDetail.amount,
              item_total: orderDetail.itemTotal,
            };
          }
        ),
      };
      const orderRes = await httpPost("/api/protected/order/create", {
        order,
        csrf,
      });
      let request = {
        eventId: portalClient.selectedEvent.eventId,
        d: {
          type: "STATIC",
          referenceid: orderRes.value.key,
          paymentmethod: {
            paymentmethodcode: "polyu.olpp.*",
            amount: Math.round(orderRes.value.total_amount * 100),
            message: orderRes.value.remarks,
          },
          callbackurl: process.env.REACT_APP_ORDER_CALLBACK_URL,
        },
      };
      if (portalClient.selectedEvent?.payerName) {
        request.d.payer_name = portalClient.selectedEvent.payerName;
      }
      if (portalClient.selectedEvent?.emailAddress) {
        request.d.payer_email = portalClient.selectedEvent.emailAddress;
      }

      await fetch("/order/checkout/paymentrequest", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
      }).then((res) => {
        if (res.redirected) {
          window.location.href = res.url;
        }
      });
    } catch (err) {
      window.location.reload();
    }
  };
}

export function getGlobalVar() {
  return async (dispatch) => {
    try {
      dispatch({ type: "DATA-LOADING-BEGIN" });
      let response = await httpGet("/api/protected/globalVar");
      if (response.result === "0") {
        dispatch(createAction(response, "GET-GLOBAL-VAR"));
      } else {
        dispatch(createErrorAction(response, "DATA-LOADING-ERROR"));
      }
    } catch (err) {
      dispatch(createErrorAction(err, "DATA-LOADING-ERROR"));
    } finally {
      dispatch({ type: "DATA-LOADING-END" });
    }
  };
}

export function getRequestAmount() {
  return async (dispatch) => {
    try {
      dispatch({ type: "DATA-LOADING-BEGIN" });
      let response = await httpGet("/api/protected/ptps/getRequestAmount");
      if (response.result === "0") {
        dispatch(createAction(response, "GET-REQUEST-AMOUNT"));
      } else {
        dispatch(createErrorAction(response, "DATA-LOADING-ERROR"));
      }
    } catch (err) {
      dispatch(createErrorAction(err, "DATA-LOADING-ERROR"));
    } finally {
      dispatch({ type: "DATA-LOADING-END" });
    }
  };
}

//e.g. : 20221201 (if today is >= 2022/12/02 and < 2023/01/01)
export function getPublicHoliday(firstOfMonth) {
  return async (dispatch) => {
    try {
      dispatch({ type: "DATA-LOADING-BEGIN" });
      let response = await httpGet(
        `/api/protected/getPublicHolidays?date=${firstOfMonth}`
      );
      if (response.result === "0") {
        dispatch(createAction(response, "SET-PUBLIC-HOLIDAY"));
      } else {
        dispatch(createErrorAction(response, "DATA-LOADING-ERROR"));
      }
    } catch (err) {
      dispatch(createErrorAction(err, "DATA-LOADING-ERROR"));
    } finally {
      dispatch({ type: "DATA-LOADING-END" });
    }
  };
}

export function getClaims(SP_DUTY_PK) {
  return async (dispatch) => {
    let response = null;
    try {
      dispatch({ type: "DATA-LOADING-BEGIN" });
      response = await httpGet(
        `/api/protected/ptps/getClaims?duty=${SP_DUTY_PK}`
      );
      if (response.result === "0") {
        dispatch(createAction(response, "SET-CLAIMS"));
      } else {
        dispatch(createErrorAction(response, "DATA-LOADING-ERROR"));
      }
    } catch (err) {
      dispatch(createErrorAction(err, "DATA-LOADING-ERROR"));
    } finally {
      dispatch({ type: "DATA-LOADING-END" });
      return response;
    }
  };
}

export function getReqDutyInfo(staffNo, staffInfo, approver) {
  return async (dispatch) => {
    try {
      dispatch({ type: "DATA-LOADING-BEGIN" });
      let response = await httpGet(
        `/api/protected/ptps/findApprovingDuty?staffNo=${staffNo}&approver=${approver}`
      );
      if (response.result === "0") {
        response.value = { ...response.value, ...staffInfo };
        dispatch(createAction(response, "SET-REQ-DUTY-INFO"));
      } else {
        dispatch(createErrorAction(response, "DATA-LOADING-ERROR"));
      }
    } catch (err) {
      dispatch(createErrorAction(err, "DATA-LOADING-ERROR"));
    } finally {
      dispatch({ type: "DATA-LOADING-END" });
    }
  };
}

export function getReqStaffInfo(approver) {
  return async (dispatch) => {
    try {
      dispatch({ type: "DATA-LOADING-BEGIN" });
      let response = await httpGet(
        `/api/protected/ptps/findApprovingStaff?approver=${approver}`
      );
      if (response.result === "0") {
        dispatch(createAction(response, "SET-REQ-STAFF-INFO"));
      } else {
        dispatch(createErrorAction(response, "DATA-LOADING-ERROR"));
      }
    } catch (err) {
      dispatch(createErrorAction(err, "DATA-LOADING-ERROR"));
    } finally {
      dispatch({ type: "DATA-LOADING-END" });
    }
  };
}

export function getFunctionsAction() {
  return async (dispatch) => {
    try {
      dispatch({ type: "DATA-LOADING-BEGIN" });
      const response = await httpGet(`/api/protected/ptps/getFunctions`);
      if (response.result === "0") {
        dispatch(createAction(response, "GET-FUNCTIONS"));
      } else {
        dispatch(createErrorAction(response, "DATA-LOADING-ERROR"));
      }
    } catch (err) {
      dispatch(createErrorAction(err, "DATA-LOADING-ERROR"));
    } finally {
      dispatch({ type: "DATA-LOADING-END" });
    }
  };
}
